import React from 'react'
import { View } from 'react-native'

import { BTN_SM, SH3 } from '@zet/design-system'
import Pressable from '@zet/design-system/pressable'
import { i18n } from '@zet/localization'

import { useCopilot } from '../../contexts/CopilotProvider'
import type { TooltipProps } from '../../types'
import { styles } from '../style'

export const Tooltip = ({ labels }: TooltipProps) => {
  const { goToNext, goToPrev, stop, currentStep, isFirstStep, isLastStep } =
    useCopilot()

  const onButtonClick = () => {
    if (!isLastStep) {
      handleNext()
    } else if (isLastStep) {
      handleStop()
    }
  }

  const handleStop = () => {
    void stop()
  }
  const handleNext = () => {
    void goToNext()
  }

  // const handlePrev = () => {
  //   void goToPrev()
  // }

  return (
    <View style={{ paddingBottom: 20 }}>
      <View style={styles.tooltipContainer}>
        <SH3 testID="stepDescription" style={styles.tooltipText}>
          {currentStep?.text}
        </SH3>
      </View>
      <View style={[styles.bottomBar]}>
        <Pressable
          onPress={onButtonClick}
          style={{
            backgroundColor: '#D4E5FE',
            paddingHorizontal: 18,
            paddingVertical: 4,
            borderRadius: 4,
            marginTop: 12,
          }}
        >
          <BTN_SM style={{ color: '#2075F0' }}>{i18n.t('coachMark.ok')}</BTN_SM>
        </Pressable>
      </View>
    </View>
  )
}
